import { mapState, mapActions } from 'vuex'

export default {
  name: 'TTablePeople',
  components: {
    TGeneralInfo: () => import('@/components/tables/general-info.vue'),
    TFileEmpty: () => import('@/components/file-empty')
  },
  data() {
    return {
      thead: [
        { label: 'Status', name: 'status' },
        { label: 'Nome do doador', name: 'name' },
        { label: 'Data de pagamento', name: 'payments.paid_at' },
        { label: 'Valor pago', name: 'payments.value' }
      ],
      totalPages: "0",
      currentPage: 1,
      pagesSelected: "0",
      total: 0,
      limit: 50,
      disabledPrev: false,
      disabledNext: false,
      titleEmpty: 'Ainda estamos importando os registros',
      content: 'Este menu ficará liberado assim que a importação for concluída, iremos de te enviar um e-mail avisando.',
      empty: false,
      currentSort: 'import_files.created_at',
      currentSortDir: 'desc'
    }
  },

  props: {
    files: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapState({
      loading: ({ people }) => people.loading,
      listPeople: ({ people }) => people.listPeople,
      metaDataPeople: ({ people }) => people.metaDataPeople,
      notFoundFilter: ({ people }) => people.notFoundFilter,
      filter: ({ people }) => people.filter,
      campaignId: ({ campaign }) => campaign.campaign.id,
      hasCampaign: ({ campaign }) => campaign.campaign
    })
  },

  methods: {
    ...mapActions('people', ['getAllPeople', 'searchPeople']),

    sort (item) {
      this.currentSortDir = this.currentSortDir === 'desc' ? 'asc' : 'desc';
      this.currentSort = item;

      this.getAllPeople(
        {
          ...this.filter,
          page: this.metaDataPeople.currentPage,
          limit: this.limit,
          campaignId: Number(this.campaignId),
          orderBy: this.currentSort,
          order: this.currentSortDir
        }
      )
    },

    statusClass (item, key) {
      if (item === 'Pago') {
        return 'color-success'
      } else if (item === 'Importado') {
        return 'color-success'
      } else if  (item === 'Importando') {
        return 'color-processing'
      } else if  (item === 'Registrado') {
        return 'color-registred'
      } else if  (item === 'Registrando') {
        return 'color-processing'
      } else if  (item === 'Falha na criação' || item === 'Falha ao registrar') {
        return 'color-error'
      }
    },

    disabledPrevButton () {
      this.metaDataPeople.currentPage === 1 ? this.disabledPrev = true : this.disabledPrev = false
    },

    disabledNextButton () {
      this.metaDataPeople.currentPage === this.metaDataPeople.totalPages ? this.disabledNext = true : this.disabledNext = false
    },

    prevPage () {
      if (this.currentPage === 1) return
      this.disabledPrevButton()
      this.disabledNextButton()

      this.getAllPeople(
        {
          ...this.filter,
          page: Number(this.currentPage) - 1,
          limit: this.limit,
          campaignId: Number(this.campaignId),
          orderBy: this.currentSort,
          order: this.currentSortDir
        }
      )
    },

    nextPage () {
      if (this.currentPage === this.totalPages) return
      this.disabledPrevButton()
      this.disabledNextButton()
      this.getAllPeople(
        {
          ...this.filter,
          page: Number(this.currentPage) + 1,
          limit: this.limit,
          campaignId: Number(this.campaignId),
          orderBy: this.currentSort,
          order: this.currentSortDir
        }
      )
    },

    goToPage (page) {
      if (Number(page) < 0 || Number(page) > Number(this.totalPages)) return
      this.disabledPrevButton()
      this.disabledNextButton()
      this.currentPage = page
      this.getAllPeople(
        {
          ...this.filter,
          page: Number(page),
          limit: this.limit,
          campaignId: Number(this.campaignId),
          orderBy: this.currentSort,
          order: this.currentSortDir
        }
      )
    },

    updateMetaDataTable () {
      if ( this.metaDataPeople ) {
        this.totalPages = `${this.metaDataPeople.totalPages}`
        this.currentPage = `${this.metaDataPeople.currentPage}`
        this.pagesSelected = `${this.metaDataPeople.limitValue}`
        this.total = this.metaDataPeople.totalCount
      }
    }
  },

  watch: {
    loading (value) {
      if (value === false) {
        if (this.notFoundFilter === false) {
          if (this.listPeople.length === 0) {
            this.empty = true
          } else {
            this.empty = false
          }
        }
      }
    }
  },

  mounted () {
    if (this.hasCampaign) {
      this.updateMetaDataTable()
      this.getAllPeople({page: Number(this.currentPage), limit: Number(this.limit), campaignId: Number(this.campaignId), orderBy: this.currentSort, order: this.currentSortDir})
    } else {
      this.empty = true
    }
  },

  updated() {
    this.updateMetaDataTable()
    this.disabledPrevButton()
    this.disabledNextButton()
  }
}
